import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatsActive: [],
  chatsNewInfo: {},
  messages: null,
  userData: {
    is_online: false,
  },
  pageInfoChats: {},
  totalUnreadMessage: null,
  userDataId: null,
  updatedNewChats: [],
};

const messagingSlice = createSlice({
  name: "messaging",
  initialState,
  reducers: {
    setChats(state, action) {
      state.chatsActive = action?.payload;
    },
    setNewChatsUpdated(state, action) {
      state.updatedNewChats = action?.payload;
    },
    setTotalUnreadMessage(state, action) {
      state.totalUnreadMessage = action?.payload;
    },
    setUserDataId(state, action) {
      state.userDataId = action?.payload;
    },
    updateTotalUnreadMessage(state, action) {
      if (action) {
        state.totalUnreadMessage =
          state.totalUnreadMessage + (action.payload ?? 0);
      }
    },
    updateMinusTotalUnreadMessage(state, action) {
      if (action) {
        state.totalUnreadMessage =
          state.totalUnreadMessage - (action.payload ?? 0);
      }
    },
    appendChats(state, action) {
      state.chatsActive.push(...action?.payload);
    },
    appendChatsNew(state, action) {
      state.updatedNewChats.push(...action?.payload);
    },
    setPageInfoChats(state, action) {
      state.pageInfoChats = action?.payload;
    },
    setNewChatsInfo(state, action) {
      state.chatsNewInfo = action?.payload;
    },
    setUserData(state, action) {
      state.userData = action?.payload;
    },
    setMessagesData(state, action) {
      state.messages = action?.payload;
    },
    clearMessagesData(state) {
      state.messages = null;
    },
    appendMessagesData(state, action) {
      const newMessages = action.payload.messages.filter((message) => {
        return !state.messages.messages.find((item) => item.id === message.id);
      });
      state.messages.messages = [...state.messages.messages, ...newMessages];
      state.messages.page = action.payload.page;
      state.messages.totalItems = action.payload.totalItems;
    },
    addNewChat(state, action) {
      state.chatsActive = [...state.chatsActive, action.payload];
    },
    setOnline: (state, action) => {
      const { member_id, isOnline } = action.payload;
      state.chatsActive = state.chatsActive?.map((item) => {
        if (item.member_id === member_id) {
          item = {
            ...item,
            is_online: isOnline,
          };
          state.userData.is_online = isOnline;
        }
        return item;
      });
    },
    setLastMessage: (state, action) => {
      const { id, message } = action.payload;
      state.chatsActive = state.chatsActive?.map((item) => {
        if (item?.id === id && state.userData.id !== id) {
          item = {
            ...item,
            last_message: message?.new_message,
            unread_messages_count: message?.unread_messages_count,
          };
        } else if (item?.id === id) {
          item = {
            ...item,
            last_message: message?.new_message,
            unread_messages_count: 0,
          };
        }
        return item;
      });
      // const last = {
      //   ...state.chatsActive?.filter((item) => item?.id === id)[0],
      // };
      if(message?.type !== 'support') {
        const withoutLast = [
          ...state.chatsActive?.filter((item) => item?.id !== id),
        ];
        const array = withoutLast;
        array.splice(1, 0, message);
        state.chatsActive = array;
      }
    },
    setChatToTop: (state, action) => {
      const { conversation_id } = action?.payload;
      const last = {
        ...state.chatsActive?.filter((item) => item?.id === conversation_id)[0],
      };
      const withoutLast = [
        ...state.chatsActive?.filter((item) => item?.id !== conversation_id),
      ];
      const array = withoutLast;
      array.splice(1, 0, last);
      state.chatsActive = array;
    },
    setNewMessageInChat: (state, action) => {
      const { id, content } = action.payload;
      if (state.userData.id === id) {
        state.messages.messages = [
          content.new_message,
          ...state.messages.messages,
        ];
      }
    },
    setViewMessage: (state, action) => {
      state.chatsActive = state.chatsActive?.map((item) => {
        if(item?.last_message?.conversation_id === action?.payload?.conversation_id) {
          item = {
            ...item,
            last_message: action?.payload
          }
        }
        return item;
      })
    },
    setReadMessage: (state, action) => {
      const { id } = action.payload;
      state.chatsActive = state.chatsActive?.map((item) => {
        if (item?.id === id) {
          item = {
            ...item,
            unread_messages_count: 0,
          };
        }
        return item;
      });
    },
  },
});

export const {
  setChats,
  setNewChatsInfo,
  addNewChat,
  setOnline,
  setUserData,
  setMessagesData,
  setLastMessage,
  setNewMessageInChat,
  setReadMessage,
  setPageInfoChats,
  appendChats,
  appendChatsNew,
  appendMessagesData,
  clearMessagesData,
  setChatToTop,
  setTotalUnreadMessage,
  updateTotalUnreadMessage,
  setUserDataId,
  setNewChatsUpdated,
  setViewMessage,
  updateMinusTotalUnreadMessage,
} = messagingSlice.actions;

export default messagingSlice.reducer;
